import { defineStore } from 'pinia';

export const usePaginaStore = defineStore('paginaStore', {
  state: () => ({
    pagina: null,
  }),
});
